/*!
  lazyhedwik.js
  A rapid, compact, and self-sufficient lazy loading script.
  (c) Hedwik Premium Ghost Themes - http://hedwik.io
  ## Usage is subject to permission; all rights belong to the Hedwik Themes.
*/
function lazyHedwikImages(){let e=new IntersectionObserver((e,a)=>{e.forEach(e=>{if(e.isIntersecting){let l=e.target;l.src=l.dataset.src,l.classList.add("loaded"),a.unobserve(l)}})});document.querySelectorAll(".lazyhedwik-image").forEach(a=>{e.observe(a)})}function lazyHedwikElement(){Array.from(document.querySelectorAll(".lazyhedwik-element")).forEach(e=>{new IntersectionObserver((e,a)=>{e.forEach(e=>{if(e.isIntersecting){let l=e.target;l.classList.add("loaded"),a.unobserve(l)}})}).observe(e)})}lazyHedwikImages(),lazyHedwikElement();



/*!
  hedwik-zoom.js
  A fast, lightweight, and independent image zooming script.
  (c) Hedwik Premium Ghost Themes - http://hedwik.io
  ## Usage is subject to permission; all rights belong to Hedwik Themes.
*/

(function () {
  "use strict";

  // Tüm .kg-image ve .kg-gallery-image img öğelerini seç ve data-action="zoom" özniteliğini ekle
  const kgImages = document.querySelectorAll('.kg-image, .kg-gallery-image img');
  kgImages.forEach(image => {
    image.setAttribute('data-action', 'zoom');
  });

  // Calculate the position of the element on the screen
  function getElementPosition(element) {
    const rect = element.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
  }

  const MARGIN = 80; // Constant value used for margins

  const zoomHandler = (function () {
    let originalHeight = null;
    let originalWidth = null;
    let overlay = null;
    let scale = null;
    let image = null;
    let wrapper = null;
    let placeholder = null;

    function loadImage() {
      const img = document.createElement("img");
      img.onload = function () {
        originalHeight = Number(img.height);
        originalWidth = Number(img.width);
        startZoom();
      };
      img.src = image.currentSrc || image.src;
    }

    function startZoom() {
      wrapper = document.createElement("div");
      wrapper.className = "zoom-img-wrap";
      wrapper.style.position = "absolute";
      wrapper.style.top = getElementPosition(image).top + "px";
      wrapper.style.left = getElementPosition(image).left + "px";

      placeholder = image.cloneNode();
      placeholder.style.visibility = "hidden";
      image.style.width = image.offsetWidth + "px";
      image.parentNode.replaceChild(placeholder, image);
      document.body.appendChild(wrapper);
      wrapper.appendChild(image);
      image.classList.add("zoom-img");
      image.setAttribute("data-action", "zoom-out");

      overlay = document.createElement("div");
      overlay.className = "zoom-overlay";
      document.body.appendChild(overlay);

      calculateScale();
      applyZoom();
    }

    function calculateScale() {
      const imgWidth = originalWidth;
      const imgHeight = originalHeight;
      const imgAspectRatio = imgWidth / image.width;
      const windowHeight = window.innerHeight - MARGIN;
      const windowWidth = window.innerWidth - MARGIN;
      const imgAspectRatioHeight = imgWidth / imgHeight;
      const windowAspectRatio = windowWidth / windowHeight;

      scale = imgWidth < windowWidth && imgHeight < windowHeight ? imgAspectRatio : imgAspectRatioHeight < windowAspectRatio ? (windowHeight / imgHeight) * imgAspectRatio : (windowWidth / imgWidth) * imgAspectRatio;
    }

    function applyZoom() {
      const imgPosition = getElementPosition(image);
      const scrollTop = window.pageYOffset;
      const centerY = scrollTop + window.innerHeight / 2;
      const centerX = window.innerWidth / 2;
      const imgCenterY = imgPosition.top + image.height / 2;
      const imgCenterX = imgPosition.left + image.width / 2;
      const translateY = Math.round(centerY - imgCenterY);
      const translateX = Math.round(centerX - imgCenterX);
      const scaleTransform = `scale(${scale})`;
      const translateTransform = `translate(${translateX}px, ${translateY}px) translateZ(0)`;

      image.style.transform = scaleTransform;
      wrapper.style.transform = translateTransform;
      document.body.classList.add("zoom-overlay-open");
    }

    function closeZoom() {
      document.body.classList.remove("zoom-overlay-open");
      document.body.classList.add("zoom-overlay-transitioning");
      image.style.transform = "";
      wrapper.style.transform = "";

      if (!("transition" in document.body.style)) {
        cleanup();
        return;
      }

      wrapper.addEventListener("transitionend", cleanup);
      wrapper.addEventListener("webkitTransitionEnd", cleanup);
    }

    function cleanup() {
      image.removeEventListener("transitionend", cleanup);
      image.removeEventListener("webkitTransitionEnd", cleanup);

      if (wrapper && wrapper.parentNode) {
        image.classList.remove("zoom-img");
        image.style.width = "";
        image.setAttribute("data-action", "zoom");
        placeholder.parentNode.replaceChild(image, placeholder);
        wrapper.parentNode.removeChild(wrapper);
        overlay.parentNode.removeChild(overlay);
        document.body.classList.remove("zoom-overlay-transitioning");
      }
    }

    return function (img) {
      image = img;
      return { zoomImage: loadImage, close: closeZoom, dispose: cleanup };
    };
  })();

  const zoomManager = (function () {
    let currentZoom = null;
    let initialScrollY = null;
    let initialTouchY = null;

    function init() {
      document.body.addEventListener("click", handleClick);
    }

    function handleClick(event) {
      if (event.target.getAttribute("data-action") === "zoom" && event.target.tagName === "IMG") {
        event.stopPropagation();
        if (!document.body.classList.contains("zoom-overlay-open")) {
          if (event.metaKey || event.ctrlKey) {
            openInNewTab(event);
          } else {
            closeCurrentZoom({ forceDispose: true });
            currentZoom = zoomHandler(event.target);
            currentZoom.zoomImage();
            addEventListeners();
          }
        }
      }
    }

    function openInNewTab(event) {
      window.open(event.target.getAttribute("data-original") || event.target.currentSrc || event.target.src, "_blank");
    }

    function closeCurrentZoom(options = { forceDispose: false }) {
      if (currentZoom) {
        currentZoom[options.forceDispose ? "dispose" : "close"]();
        removeEventListeners();
        currentZoom = null;
      }
    }

    function addEventListeners() {
      window.addEventListener("scroll", handleScroll);
      document.addEventListener("click", handleDocumentClick);
      document.addEventListener("keyup", handleKeyUp);
      document.addEventListener("touchstart", handleTouchStart);
      document.addEventListener("touchend", handleDocumentClick);
    }

    function removeEventListeners() {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("keyup", handleKeyUp);
      document.removeEventListener("click", handleDocumentClick);
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchend", handleDocumentClick);
    }

    function handleScroll() {
      if (initialScrollY === null) {
        initialScrollY = window.pageYOffset;
      }
      const scrollDifference = initialScrollY - window.pageYOffset;
      if (Math.abs(scrollDifference) >= 40) {
        closeCurrentZoom();
      }
    }

    function handleKeyUp(event) {
      if (event.keyCode === 27) { // Escape key
        closeCurrentZoom();
      }
    }

    function handleDocumentClick(event) {
      event.stopPropagation();
      event.preventDefault();
      closeCurrentZoom();
    }

    function handleTouchStart(event) {
      initialTouchY = event.touches[0].pageY;
      event.target.addEventListener("touchmove", handleTouchMove);
    }

    function handleTouchMove(event) {
      if (Math.abs(event.touches[0].pageY - initialTouchY) > 10) {
        closeCurrentZoom();
        event.target.removeEventListener("touchmove", handleTouchMove);
      }
    }

    return { listen: init };
  })();

  zoomManager.listen();
})();
